import React, { SVGProps } from "react";
import { StaticImage } from "gatsby-plugin-image";

export const StarsIconV2SectionHeader = () => (
	<StaticImage loading="eager" src="./stars-03.png" alt="stars pattern" />
);

export const FeatureSummaryPattern = () => (
	<StaticImage
		loading="eager"
		src="./feature_summary.png"
		alt="feature summary"
	/>
);

export const FeatureROI = () => (
	<StaticImage
		loading="eager"
		src="../products/roi.png"
		alt="feature summary"
	/>
);

export const GenemodWhiteLogo = () => (
	<StaticImage
		loading="eager"
		src="../images/logos/logo-white.png"
		alt="Genemod White Logo"
	/>
);

export const GenemodGrayLogo = () => (
	<StaticImage
		loading="eager"
		src="../images/logos/with-gray-title.svg"
		alt="Genemod Gray Logo"
	/>
);

export const AIIcon = () => (
	<StaticImage loading="eager" src="./ai.svg" alt="ai sparkle" />
);

export const StarPattern = () => (
	<StaticImage loading="eager" src="./star-04.svg" alt="star" />
);
type IArrowColors =
	| "medium_pink"
	| "marine"
	| "ui_01"
	| "brand"
	| "primary"
	| "brand-primary"
	| "brand-primary-2";
export const ArrowLeftIcons = (
	color: IArrowColors,
	type?: "arrow-cirle-left"
) => {
	switch (color) {
		case "brand":
			if (type === "arrow-cirle-left") {
				return (
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="32"
						height="32"
						viewBox="0 0 32 32"
						fill="none"
					>
						<rect
							x="31"
							y="31"
							width="30"
							height="30"
							rx="15"
							transform="rotate(-180 31 31)"
							stroke="white"
							stroke-width="2"
						/>
						<path
							d="M10.2929 15.0351C9.90237 15.4256 9.90237 16.0588 10.2929 16.4493L16.6569 22.8133C17.0474 23.2038 17.6805 23.2038 18.0711 22.8133C18.4616 22.4227 18.4616 21.7896 18.0711 21.399L12.4142 15.7422L18.0711 10.0853C18.4616 9.69481 18.4616 9.06164 18.0711 8.67112C17.6805 8.2806 17.0474 8.2806 16.6569 8.67112L10.2929 15.0351ZM12 14.7422H11V16.7422H12V14.7422Z"
							fill="white"
						/>
					</svg>
				);
			}
			return;
		default:
			return;
	}
};

export const ArrowRightIcons = (
	color: IArrowColors,
	type?: "arrow-right" | "arrow-narrow-right" | "arrow-cirle-right"
) => {
	switch (color) {
		case "brand-primary-2":
			return (
				<StaticImage
					loading="eager"
					src={"./arrow-tailed(brand-primary-2).svg"}
					alt="right arrow"
					style={{
						width: 24,
						height: 24,
						flexShrink: 0,
					}}
				/>
			);
		case "medium_pink":
			return (
				<StaticImage
					loading="eager"
					src={"./arrow-tailed(medium-pink).png"}
					alt="right arrow"
					style={{
						width: 15,
						height: 15,
						flexShrink: 0,
					}}
				/>
			);
		case "marine":
			if (type === "arrow-narrow-right") {
				// For some reason passing a const into src doesn't load the image
				return (
					<svg
						width="29"
						height="28"
						viewBox="0 0 29 28"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M5.16667 14H23.8333M23.8333 14L16.8333 7M23.8333 14L16.8333 21"
							stroke="#051D85"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
				);
			}
			return (
				<StaticImage
					loading="eager"
					src={"./arrow-tailed(marine).png"}
					alt="right arrow"
					style={{
						width: 15,
						height: 15,
						flexShrink: 0,
					}}
				/>
			);
		case "primary":
			if (type === "arrow-narrow-right") {
				// For some reason passing a const into src doesn't load the image
				return (
					<svg
						width="29"
						height="28"
						viewBox="0 0 29 28"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M5.16667 14H23.8333M23.8333 14L16.8333 7M23.8333 14L16.8333 21"
							stroke="#051D85"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
				);
			}
			return (
				<StaticImage
					loading="eager"
					src={"./arrow-right.png"}
					alt="right arrow"
					style={{
						width: 15,
						height: 15,
						flexShrink: 0,
					}}
				/>
			);
		case "brand":
			if (type === "arrow-cirle-right") {
				return (
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="32"
						height="32"
						viewBox="0 0 32 32"
						fill="none"
					>
						<rect
							x="1"
							y="1"
							width="30"
							height="30"
							rx="15"
							stroke="white"
							stroke-width="2"
						/>
						<path
							d="M21.7071 16.4493C22.0976 16.0588 22.0976 15.4256 21.7071 15.0351L15.3431 8.67112C14.9526 8.2806 14.3195 8.2806 13.9289 8.67112C13.5384 9.06164 13.5384 9.69481 13.9289 10.0853L19.5858 15.7422L13.9289 21.399C13.5384 21.7896 13.5384 22.4227 13.9289 22.8133C14.3195 23.2038 14.9526 23.2038 15.3431 22.8133L21.7071 16.4493ZM20 16.7422H21V14.7422H20V16.7422Z"
							fill="white"
						/>
					</svg>
				);
			}
			return (
				<StaticImage
					loading="eager"
					src={"./arrow-tailed(brand).png"}
					alt="right arrow"
					style={{
						width: 15,
						height: 15,
						flexShrink: 0,
					}}
				/>
			);
		case "ui_01":
			return (
				<StaticImage
					loading="eager"
					src={"./arrow-tailed(white).png"}
					alt="right arrow"
					style={{
						width: 15,
						height: 15,
						flexShrink: 0,
					}}
				/>
			);
		case "brand-primary":
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
				>
					<path
						d="M4 12H20M20 12L14 6M20 12L14 18"
						stroke="#57A9F4"
						stroke-width="1.5"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</svg>
			);
	}
};

export const Biopharmaceutical = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_261_9607)">
				<path d="M24 0H0V24H24V0Z" fill="white" />
				<path
					d="M9.83969 9.58984V12.3998C9.83969 13.1998 9.55969 13.9798 9.03969 14.5998L6.01969 18.1898C5.47969 18.8298 5.17969 19.6398 5.17969 20.4798C5.17969 21.0698 5.65969 21.5498 6.24969 21.5498H12.0697"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M12.1419 9.58984H8.17188"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M12.2695 9.58984H16.2295"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M14.4292 9.58984V12.3998C14.4292 13.1998 14.7092 13.9798 15.2292 14.5998L18.2492 18.1898C18.7892 18.8298 19.0892 19.6398 19.0892 20.4798C19.0892 21.0698 18.6092 21.5498 18.0192 21.5498H12.1992"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M8.21875 15.5703H16.0488"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M12.0703 17.7201V7.08008"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M5.46875 3.17969C5.46875 3.17969 6.04875 7.74969 11.7688 7.74969C11.7688 7.74969 11.5287 3.17969 5.46875 3.17969Z"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M18.5992 2.52033C18.5992 2.52033 14.0892 1.56034 12.1992 6.95034C12.1992 6.95034 16.5892 8.24033 18.5992 2.52033Z"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_261_9607">
					<rect width="24" height="24" rx="2" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const IndustrialBiotech = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_261_5441)">
				<path d="M24 0H0V24H24V0Z" fill="white" />
				<path
					d="M10.8906 21.3104C10.8906 18.7404 12.3406 16.6504 14.1306 16.6504C15.9206 16.6504 17.3706 18.7304 17.3706 21.3104"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M17.3706 12.0005C17.3706 14.5705 15.9206 16.6605 14.1306 16.6605C12.3406 16.6605 10.8906 14.5805 10.8906 12.0005"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M17.3706 2.69043C17.3706 5.26043 15.9206 7.35043 14.1306 7.35043C12.3406 7.35043 10.8906 5.27043 10.8906 2.69043"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M10.8906 12.0003C10.8906 9.43032 12.3406 7.34033 14.1306 7.34033C15.9206 7.34033 17.3706 9.42032 17.3706 12.0003"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M11.6206 14.3303H16.6406"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M10.8906 12.0005H17.3706"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M11.6206 9.54053H16.6406"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M11.4987 5.22949H10.5788C10.3388 5.22949 10.1388 5.42949 10.1388 5.66949V6.38948C10.1388 6.58948 10.0087 6.75949 9.81875 6.80949C9.52875 6.89949 9.24875 7.00948 8.97875 7.13948C8.80875 7.22948 8.59875 7.19949 8.46875 7.05949L7.97875 6.56949C7.80875 6.39949 7.52875 6.39949 7.35875 6.56949L6.05875 7.86949C5.88875 8.03949 5.88875 8.31949 6.05875 8.48949L6.51875 8.94949C6.65875 9.08949 6.67875 9.29948 6.58875 9.46948C6.43875 9.74948 6.31875 10.0395 6.21875 10.3395C6.15875 10.5295 5.99875 10.6595 5.79875 10.6595H5.15875C4.91875 10.6595 4.71875 10.8595 4.71875 11.0995V12.9295C4.71875 13.1695 4.91875 13.3695 5.15875 13.3695H5.80875C5.99875 13.3695 6.16875 13.4995 6.22875 13.6795C6.32875 13.9795 6.44875 14.2695 6.59875 14.5395C6.68875 14.7095 6.66876 14.9295 6.52876 15.0695L6.05875 15.5395C5.88875 15.7095 5.88875 15.9895 6.05875 16.1595L7.35875 17.4595C7.52875 17.6295 7.80875 17.6295 7.97875 17.4595L8.48875 16.9495C8.61875 16.8195 8.82875 16.7895 8.99875 16.8695C9.26875 16.9995 9.53875 17.1095 9.82875 17.1895C10.0188 17.2495 10.1488 17.4095 10.1488 17.6095V18.3495C10.1488 18.5895 10.3488 18.7895 10.5888 18.7895H11.5088"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
			</g>
			<defs>
				<clipPath id="clip0_261_5441">
					<rect width="24" height="24" rx="2" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const ClinicalResearch = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_261_7628)">
				<path d="M24 0H0V24H24V0Z" fill="white" />
				<path
					d="M12.1406 22C17.6635 22 22.1406 17.5228 22.1406 12C22.1406 6.47715 17.6635 2 12.1406 2C6.61778 2 2.14062 6.47715 2.14062 12C2.14062 17.5228 6.61778 22 12.1406 22Z"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M18.4489 9.37024H15.4489C15.0689 9.37024 14.7589 9.06024 14.7589 8.68024V5.68024C14.7589 5.30024 14.4489 4.99023 14.0689 4.99023H10.1989C9.81891 4.99023 9.5089 5.30024 9.5089 5.68024V8.68024C9.5089 9.06024 9.1989 9.37024 8.8189 9.37024H5.8189C5.4389 9.37024 5.12891 9.68024 5.12891 10.0602V13.9302C5.12891 14.3102 5.4389 14.6202 5.8189 14.6202H8.8189C9.1989 14.6202 9.5089 14.9302 9.5089 15.3102V18.3102C9.5089 18.6902 9.81891 19.0002 10.1989 19.0002H14.0689C14.4489 19.0002 14.7589 18.6902 14.7589 18.3102V15.3102C14.7589 14.9302 15.0689 14.6202 15.4489 14.6202H18.4489C18.8289 14.6202 19.1389 14.3102 19.1389 13.9302V10.0602C19.1389 9.68024 18.8289 9.37024 18.4489 9.37024Z"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_261_7628">
					<rect width="24" height="24" rx="2" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const Biomanufacturers = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_261_11093)">
				<path d="M24 0H0V24H24V0Z" fill="white" />
				<path
					d="M10.4788 21.7099C10.4788 19.0299 11.9888 16.8599 13.8588 16.8599C15.7288 16.8599 17.2388 19.0299 17.2388 21.7099"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M17.2287 11.9998C17.2287 14.6798 15.7187 16.8498 13.8487 16.8498C13.2387 16.8498 12.6587 16.6197 12.1687 16.2097"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M17.2288 2.2998C17.2288 4.9798 15.7188 7.14981 13.8488 7.14981C11.9788 7.14981 10.4688 4.9798 10.4688 2.2998"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M11.3887 8.68991C12.0087 7.73991 12.8787 7.1499 13.8587 7.1499C15.7287 7.1499 17.2387 9.31991 17.2387 11.9999"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M9.15993 17.0596C11.6342 17.0596 13.6399 15.0538 13.6399 12.5796C13.6399 10.1054 11.6342 8.09961 9.15993 8.09961C6.6857 8.09961 4.67993 10.1054 4.67993 12.5796C4.67993 15.0538 6.6857 17.0596 9.15993 17.0596Z"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M6.72 16.3296L4.25 20.1296"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_261_11093">
					<rect width="24" height="24" rx="2" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const Biorepositories = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_261_11672)">
				<path d="M24 0H0V24H24V0Z" fill="white" />
				<path
					d="M9.87109 20.8803C9.87109 19.0503 10.9011 17.5703 12.1711 17.5703C13.4411 17.5703 14.4711 19.0503 14.4711 20.8803"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M14.4789 14.2695C14.4789 16.0995 13.4489 17.5795 12.1789 17.5795C10.9089 17.5795 9.87891 16.0995 9.87891 14.2695"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M14.4789 7.65039C14.4789 9.48039 13.4489 10.9604 12.1789 10.9604C10.9089 10.9604 9.87891 9.48039 9.87891 7.65039"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M9.87109 14.27C9.87109 12.44 10.9011 10.96 12.1711 10.96C13.4411 10.96 14.4711 12.44 14.4711 14.27"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M4.67969 20.8799V10.96"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M4.67969 20.8799V10.96"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M19.8203 20.8799V10.96"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M3.28906 11.5996L11.1591 3.72957C11.7191 3.16957 12.6391 3.16957 13.1991 3.72957L21.0691 11.5996"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_261_11672">
					<rect width="24" height="24" rx="2" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const ContractServices = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_261_10372)">
				<path d="M24 0H0V24H24V0Z" fill="white" />
				<path
					d="M13.2192 2H11.8692C11.5092 2 11.2192 2.28999 11.2192 2.64999V3.70999C11.2192 3.99999 11.0192 4.24999 10.7392 4.32999C10.3092 4.45999 9.89921 4.61998 9.49921 4.81998C9.24921 4.94998 8.93922 4.90999 8.73922 4.70999L8.00922 3.97998C7.75922 3.72998 7.34922 3.72998 7.08922 3.97998L5.17921 5.88998C4.92921 6.13998 4.92921 6.55 5.17921 6.81L5.85921 7.48999C6.06921 7.69999 6.09922 8.00998 5.95922 8.25998C5.73922 8.66998 5.55922 9.09998 5.41922 9.53998C5.32922 9.80998 5.08922 10.01 4.79922 10.01H3.84922C3.48922 10.01 3.19922 10.3 3.19922 10.66V13.36C3.19922 13.72 3.48922 14.01 3.84922 14.01H4.80922C5.09922 14.01 5.33921 14.2 5.42921 14.47C5.56921 14.91 5.75922 15.34 5.96922 15.74C6.10922 16 6.06922 16.31 5.86922 16.52L5.17921 17.21C4.92921 17.46 4.92921 17.87 5.17921 18.13L7.08922 20.04C7.33922 20.29 7.74922 20.29 8.00922 20.04L8.75922 19.29C8.95922 19.09 9.24922 19.05 9.50922 19.18C9.89922 19.37 10.3092 19.53 10.7292 19.66C11.0092 19.74 11.1992 19.99 11.1992 20.28V21.38C11.1992 21.74 11.4892 22.03 11.8492 22.03H13.1992"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M10.9102 8.60007L11.7402 9.58008L13.4402 7.58008"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M15.9688 9.2002H21.4388"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M10.9102 13.02L11.7402 14L13.4402 12"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M15.9688 13.6201H21.4388"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_261_10372">
					<rect width="24" height="24" rx="2" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const ProfessionalServices = () => {
	return (
		<svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M10.0004 14.5C11.3811 14.5 12.5004 13.3807 12.5004 12C12.5004 10.6193 11.3811 9.5 10.0004 9.5C8.61967 9.5 7.50039 10.6193 7.50039 12C7.50039 13.3807 8.61967 14.5 10.0004 14.5Z" stroke="#2C52F7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M7.74129 18.1426L8.22833 19.238C8.37311 19.564 8.60939 19.8411 8.90852 20.0355C9.20764 20.2299 9.55675 20.3334 9.91351 20.3333C10.2703 20.3334 10.6194 20.2299 10.9185 20.0355C11.2176 19.8411 11.4539 19.564 11.5987 19.238L12.0857 18.1426C12.2591 17.7539 12.5507 17.4299 12.9191 17.2167C13.2897 17.0029 13.7185 16.9118 14.1441 16.9565L15.3357 17.0833C15.6905 17.1209 16.0485 17.0547 16.3663 16.8928C16.6842 16.7309 16.9482 16.4803 17.1265 16.1713C17.305 15.8625 17.39 15.5086 17.3713 15.1524C17.3525 14.7962 17.2308 14.4532 17.0209 14.1648L16.3154 13.1954C16.0641 12.8476 15.9299 12.429 15.932 12C15.932 11.5722 16.0675 11.1553 16.3191 10.8093L17.0246 9.83981C17.2345 9.55146 17.3562 9.20839 17.375 8.85223C17.3937 8.49606 17.3087 8.14212 17.1302 7.83333C16.9519 7.52436 16.6879 7.27374 16.37 7.11185C16.0522 6.94997 15.6942 6.88377 15.3394 6.92129L14.1478 7.04815C13.7222 7.09284 13.2934 7.00177 12.9228 6.78796C12.5537 6.57354 12.262 6.2478 12.0894 5.85741L11.5987 4.76203C11.4539 4.43597 11.2176 4.15893 10.9185 3.9645C10.6194 3.77007 10.2703 3.66661 9.91351 3.66666C9.55675 3.66661 9.20764 3.77007 8.90852 3.9645C8.60939 4.15893 8.37311 4.43597 8.22833 4.76203L7.74129 5.85741C7.56873 6.2478 7.27702 6.57354 6.90796 6.78796C6.5373 7.00177 6.10852 7.09284 5.68296 7.04815L4.48759 6.92129C4.13286 6.88377 3.77487 6.94997 3.45702 7.11185C3.13916 7.27374 2.8751 7.52436 2.69685 7.83333C2.51836 8.14212 2.43333 8.49606 2.45207 8.85223C2.47081 9.20839 2.59251 9.55146 2.8024 9.83981L3.50796 10.8093C3.75957 11.1553 3.89507 11.5722 3.89499 12C3.89507 12.4278 3.75957 12.8447 3.50796 13.1907L2.8024 14.1602C2.59251 14.4485 2.47081 14.7916 2.45207 15.1478C2.43333 15.5039 2.51836 15.8579 2.69685 16.1667C2.87528 16.4755 3.13937 16.726 3.45718 16.8878C3.77499 17.0497 4.13289 17.116 4.48759 17.0787L5.67925 16.9519C6.10481 16.9072 6.5336 16.9982 6.90425 17.212C7.27469 17.4258 7.56776 17.7517 7.74129 18.1426Z" stroke="#2C52F7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
		</svg>
	);
}
export const CellTherapy = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_261_11161)">
				<path d="M24 0H0V24H24V0Z" fill="white" />
				<path
					d="M1.71875 17.4098C3.81875 15.3098 6.71875 14.7898 8.17875 16.2498C9.63875 17.7098 9.12875 20.6098 7.01875 22.7098"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M14.6488 15.09C12.5488 17.19 9.64883 17.71 8.18883 16.25C6.72883 14.79 7.23883 11.89 9.34883 9.79004"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M22.2787 7.46992C20.1787 9.56992 17.2787 10.0899 15.8187 8.62992C14.3587 7.16992 14.8687 4.26992 16.9787 2.16992"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M9.34863 9.77994C11.4486 7.67994 14.3486 7.15994 15.8086 8.61994C17.2686 10.0799 16.7586 12.9799 14.6486 15.0799"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M8.03882 12.29L12.1488 16.4"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M9.34863 9.78003L14.6486 15.09"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M11.9587 8.36987L16.0687 12.4799"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_261_11161">
					<rect width="24" height="24" rx="2" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const RNA = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_261_14828)">
				<path d="M24 0H0V24H24V0Z" fill="white" />
				<path
					d="M7.89844 2.7998C7.89844 2.7998 8.24844 8.4698 12.6484 12.1198C17.0484 15.7698 15.9884 22.4498 15.9884 22.4498"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M8.01855 3.71973H14.4186"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M8.8584 6.19971H14.4184"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M9.9585 8.66992H14.4185"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M11.9985 11.1399H14.4185"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M8.01855 3.71973H14.4186"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M8.8584 6.19971H14.4184"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M9.9585 8.66992H14.4185"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M11.9985 11.1399H14.4185"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M16.1285 22.1797H9.71851"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M16.0586 19.7097H10.7686"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M15.5484 17.2397H11.3484"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M14.4185 14.7698H12.2585"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_261_14828">
					<rect width="24" height="24" rx="2" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const Antibodies = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_261_215)">
				<path d="M24 0H0V24H24V0Z" fill="white" />
				<path
					d="M11.06 20.4803V12.0003L5.75 4.57031"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M7.56781 10.8298L4.00781 5.83984"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M11.06 20.4803V12.0003L5.75 4.57031"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M7.56781 10.8298L4.00781 5.83984"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M13.9805 20.4803V12.0003L19.2905 4.57031"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M17.4688 10.8298L21.0387 5.83984"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_261_215">
					<rect width="24" height="24" rx="2" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const Chemistry = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_261_11192)">
				<path d="M24 0H0V24H24V0Z" fill="white" />
				<path
					d="M11.8516 15C13.5084 15 14.8516 13.6569 14.8516 12C14.8516 10.3431 13.5084 9 11.8516 9C10.1947 9 8.85156 10.3431 8.85156 12C8.85156 13.6569 10.1947 15 11.8516 15Z"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M6.10156 22.5596C7.75842 22.5596 9.10156 21.2164 9.10156 19.5596C9.10156 17.9027 7.75842 16.5596 6.10156 16.5596C4.44471 16.5596 3.10156 17.9027 3.10156 19.5596C3.10156 21.2164 4.44471 22.5596 6.10156 22.5596Z"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M16.9102 21.5596C18.0147 21.5596 18.9102 20.6641 18.9102 19.5596C18.9102 18.455 18.0147 17.5596 16.9102 17.5596C15.8056 17.5596 14.9102 18.455 14.9102 19.5596C14.9102 20.6641 15.8056 21.5596 16.9102 21.5596Z"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M19.8984 16C21.003 16 21.8984 15.1046 21.8984 14C21.8984 12.8954 21.003 12 19.8984 12C18.7939 12 17.8984 12.8954 17.8984 14C17.8984 15.1046 18.7939 16 19.8984 16Z"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M18.9102 6.31934C20.2909 6.31934 21.4102 5.20005 21.4102 3.81934C21.4102 2.43862 20.2909 1.31934 18.9102 1.31934C17.5294 1.31934 16.4102 2.43862 16.4102 3.81934C16.4102 5.20005 17.5294 6.31934 18.9102 6.31934Z"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M4.91016 6.98926C6.29087 6.98926 7.41016 5.86997 7.41016 4.48926C7.41016 3.10855 6.29087 1.98926 4.91016 1.98926C3.52944 1.98926 2.41016 3.10855 2.41016 4.48926C2.41016 5.86997 3.52944 6.98926 4.91016 6.98926Z"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M9.77937 9.83933L6.60938 6.31934"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M13.9297 9.83922L17.6097 5.94922"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M14.9102 12.4893L18.0002 13.3893"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M13.3203 14.5996L15.7703 17.9196"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M10.3694 14.5996L7.85938 17.1196"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
			</g>
			<defs>
				<clipPath id="clip0_261_11192">
					<rect width="24" height="24" rx="2" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const Biopharma = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_261_11228)">
				<path d="M24 0H0V24H24V0Z" fill="white" />
				<path
					d="M16.7999 19.1399H3.9499C3.23193 19.1399 2.6499 19.7219 2.6499 20.4399V21.1299C2.6499 21.8479 3.23193 22.4299 3.9499 22.4299H16.7999C17.5179 22.4299 18.0999 21.8479 18.0999 21.1299V20.4399C18.0999 19.7219 17.5179 19.1399 16.7999 19.1399Z"
					stroke="#5D7AF9"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M15.99 10.9901C15.39 11.3901 14.57 11.3201 14.04 10.7901L11.77 8.52007C11.16 7.91007 11.16 6.93007 11.77 6.33007L14.58 3.52007C15.18 2.92007 16.16 2.92007 16.77 3.52007L19.04 5.79007C19.57 6.32007 19.64 7.14007 19.24 7.74007"
					stroke="#5D7AF9"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M16.3501 3.18996L17.4101 2.12996C17.7201 1.81996 18.2201 1.81996 18.5301 2.12996L20.4001 3.99996C20.7101 4.30996 20.7101 4.80996 20.4001 5.11996L19.3401 6.17996"
					stroke="#5D7AF9"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M14.3899 11.1399L13.3299 12.1999C13.0199 12.5099 12.5199 12.5099 12.2099 12.1999L10.3399 10.3299C10.0299 10.0199 10.0299 9.5199 10.3399 9.2099L11.3999 8.1499"
					stroke="#5D7AF9"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M18.1599 12.21C19.3915 12.21 20.3899 11.2116 20.3899 9.98C20.3899 8.7484 19.3915 7.75 18.1599 7.75C16.9283 7.75 15.9299 8.7484 15.9299 9.98C15.9299 11.2116 16.9283 12.21 18.1599 12.21Z"
					stroke="#5D7AF9"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M4.19995 17.1899H15.35"
					stroke="#5D7AF9"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M19.9999 11.4199C19.8999 14.3799 18.5299 17.0199 16.4099 18.7999"
					stroke="#5D7AF9"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M17.33 12.3799C17 14.2599 15.98 15.8999 14.54 17.0199"
					stroke="#5D7AF9"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_261_11228">
					<rect width="24" height="24" rx="2" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const Startups = () => {
	return (
		<svg
			width="22"
			height="20"
			viewBox="0 0 22 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M6.5 9H3.6C3.03995 9 2.75992 9 2.54601 9.10899C2.35785 9.20487 2.20487 9.35785 2.10899 9.54601C2 9.75992 2 10.0399 2 10.6V19M15.5 9H18.4C18.9601 9 19.2401 9 19.454 9.10899C19.6422 9.20487 19.7951 9.35785 19.891 9.54601C20 9.75992 20 10.0399 20 10.6V19M15.5 19V4.2C15.5 3.0799 15.5 2.51984 15.282 2.09202C15.0903 1.71569 14.7843 1.40973 14.408 1.21799C13.9802 1 13.4201 1 12.3 1H9.7C8.57989 1 8.01984 1 7.59202 1.21799C7.21569 1.40973 6.90973 1.71569 6.71799 2.09202C6.5 2.51984 6.5 3.0799 6.5 4.2V19M21 19H1M10 5H12M10 9H12M10 13H12"
				stroke="#2C52F7"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
};

export const Academia = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_261_11292)">
				<path
					d="M22 9L12 5L2 9L12 13L22 9ZM22 9V15"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M6 10.6001V16.0001C6 16.7957 6.63214 17.5588 7.75736 18.1214C8.88258 18.684 10.4087 19.0001 12 19.0001C13.5913 19.0001 15.1174 18.684 16.2426 18.1214C17.3679 17.5588 18 16.7957 18 16.0001V10.6001"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_261_11292">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
export const BiopharmaIcon = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M16.8 19.1399H3.94999C3.23202 19.1399 2.64999 19.7219 2.64999 20.4399V21.1299C2.64999 21.8479 3.23202 22.4299 3.94999 22.4299H16.8C17.518 22.4299 18.1 21.8479 18.1 21.1299V20.4399C18.1 19.7219 17.518 19.1399 16.8 19.1399Z"
			stroke="#2C52F7"
			stroke-width="1.5"
			stroke-miterlimit="10"
		/>
		<path
			d="M15.99 10.9901C15.39 11.3901 14.57 11.3201 14.04 10.7901L11.77 8.52007C11.16 7.91007 11.16 6.93007 11.77 6.33007L14.58 3.52007C15.18 2.92007 16.16 2.92007 16.77 3.52007L19.04 5.79007C19.57 6.32007 19.64 7.14007 19.24 7.74007"
			stroke="#2C52F7"
			stroke-width="1.5"
			stroke-miterlimit="10"
		/>
		<path
			d="M16.35 3.18996L17.41 2.12996C17.72 1.81996 18.22 1.81996 18.53 2.12996L20.4 3.99996C20.71 4.30996 20.71 4.80996 20.4 5.11996L19.34 6.17996"
			stroke="#2C52F7"
			stroke-width="1.5"
			stroke-miterlimit="10"
		/>
		<path
			d="M14.39 11.1399L13.33 12.1999C13.02 12.5099 12.52 12.5099 12.21 12.1999L10.34 10.3299C10.03 10.0199 10.03 9.5199 10.34 9.2099L11.4 8.1499"
			stroke="#2C52F7"
			stroke-width="1.5"
			stroke-miterlimit="10"
		/>
		<path
			d="M18.16 12.21C19.3916 12.21 20.39 11.2116 20.39 9.98C20.39 8.7484 19.3916 7.75 18.16 7.75C16.9284 7.75 15.93 8.7484 15.93 9.98C15.93 11.2116 16.9284 12.21 18.16 12.21Z"
			stroke="#2C52F7"
			stroke-width="1.5"
			stroke-miterlimit="10"
		/>
		<path
			d="M4.19998 17.1899H15.35"
			stroke="#2C52F7"
			stroke-width="1.5"
			stroke-miterlimit="10"
			stroke-linecap="round"
		/>
		<path
			d="M20 11.4199C19.9 14.3799 18.53 17.0199 16.41 18.7999"
			stroke="#2C52F7"
			stroke-width="1.5"
			stroke-miterlimit="10"
			stroke-linecap="round"
		/>
		<path
			d="M17.33 12.3799C17 14.2599 15.98 15.8999 14.54 17.0199"
			stroke="#2C52F7"
			stroke-width="1.5"
			stroke-miterlimit="10"
			stroke-linecap="round"
		/>
	</svg>
);

export const CRO = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_261_376)">
				<path d="M24 0H0V24H24V0Z" fill="white" />
				<path
					d="M19.5 11.5V10.4157C19.5 10.1248 19.2767 9.9 19.0161 9.9H18.2221C17.9988 9.9 17.8127 9.74132 17.7506 9.51653C17.6514 9.17273 17.5273 8.84215 17.3908 8.52479C17.2916 8.32645 17.3288 8.07521 17.4777 7.91653L18.0236 7.33471C18.2097 7.13636 18.2097 6.80578 18.0236 6.60744L16.5844 5.07355C16.3983 4.87521 16.0881 4.87521 15.902 5.07355L15.3933 5.6157C15.2444 5.77438 15.0087 5.81405 14.8102 5.69504C14.5 5.52314 14.1774 5.37769 13.8424 5.25868C13.6315 5.19256 13.495 4.99421 13.495 4.76942V4.0157C13.495 3.72479 13.2717 3.5 13.0112 3.5H10.9764C10.7035 3.5 10.4926 3.73802 10.4926 4.0157V4.78264C10.4926 5.00744 10.3437 5.20578 10.1452 5.2719C9.81017 5.39091 9.5 5.53636 9.18983 5.70826C8.99132 5.81405 8.76799 5.7876 8.6067 5.62893L8.08561 5.07355C7.8995 4.87521 7.58933 4.87521 7.40323 5.07355L5.96402 6.60744C5.77792 6.80578 5.77792 7.13636 5.96402 7.33471L6.53474 7.94297C6.68362 8.10165 6.70844 8.33967 6.62159 8.53802C6.4727 8.85537 6.36104 9.17273 6.26179 9.51653C6.19975 9.74132 6.01365 9.9 5.80273 9.9H4.98387C4.71092 9.9 4.5 10.138 4.5 10.4157V11.5"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
				/>
				<path
					d="M4.10156 11.3896V14.7796C4.10156 15.1296 4.32156 15.4496 4.65156 15.5896L10.0216 17.7396C10.3516 17.8696 10.5716 18.1896 10.5716 18.5496V20.3496C10.5716 20.8296 10.9616 21.2196 11.4416 21.2196H12.0116"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M19.9016 11.3896H4.10156"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
				<path
					d="M19.8514 11.3896V14.7796C19.8514 15.1296 19.6314 15.4496 19.3014 15.5896L13.9314 17.7396C13.6014 17.8696 13.3814 18.1896 13.3814 18.5496V20.3496C13.3814 20.8296 12.9914 21.2196 12.5114 21.2196H11.9414"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-miterlimit="10"
					stroke-linecap="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_261_376">
					<rect width="24" height="24" rx="2" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const Excel = () => {
	return (
		<StaticImage
			src={
				"../../pages/comparisons/_versusHelper/images/excel-logo-mobile.png"
			}
			alt="Genemod vs Excel"
			style={{
				height: 20,
				width: 20,
			}}
		/>
	);
};

export const LabArchives = () => {
	return (
		<StaticImage
			src={
				"../../pages/comparisons/_versusHelper/images/lab-archives-logo-mobile.png"
			}
			alt="Genemod vs LabArchives"
			style={{
				height: 20,
				width: 20,
			}}
		/>
	);
};

export const Quartzy = () => {
	return (
		<StaticImage
			src={
				"../../pages/comparisons/_versusHelper/images/quartzy-logo-mobile.png"
			}
			alt="Genemod vs Quartzy"
			style={{
				height: 20,
				width: 20,
			}}
		/>
	);
};

export const FreezerPro = () => {
	return (
		<StaticImage
			src={"../../components/Header/img/FreezerPro.png"}
			alt="Genemod vs Quartzy"
			style={{
				height: 20,
				width: 20,
			}}
		/>
	);
};

export const Blogs = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_261_1020)">
				<path
					d="M6 15H21"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M21 19H6"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M15 11H21"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M21 7H15"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M9 9H10C10.1978 9 10.3911 9.05865 10.5556 9.16853C10.72 9.27841 10.8482 9.43459 10.9239 9.61732C10.9996 9.80004 11.0194 10.0011 10.9808 10.1951C10.9422 10.3891 10.847 10.5673 10.7071 10.7071C10.5673 10.847 10.3891 10.9422 10.1951 10.9808C10.0011 11.0194 9.80004 10.9996 9.61732 10.9239C9.43459 10.8482 9.27841 10.72 9.16853 10.5556C9.05865 10.3911 9 10.1978 9 10V7.5C9 6.96957 9.21071 6.46086 9.58579 6.08579C9.96086 5.71071 10.4696 5.5 11 5.5"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M3 9H4C4.19778 9 4.39112 9.05865 4.55557 9.16853C4.72002 9.27841 4.84819 9.43459 4.92388 9.61732C4.99957 9.80004 5.01937 10.0011 4.98079 10.1951C4.9422 10.3891 4.84696 10.5673 4.70711 10.7071C4.56725 10.847 4.38907 10.9422 4.19509 10.9808C4.00111 11.0194 3.80004 10.9996 3.61732 10.9239C3.43459 10.8482 3.27841 10.72 3.16853 10.5556C3.05865 10.3911 3 10.1978 3 10V7.5C3 6.96957 3.21071 6.46086 3.58579 6.08579C3.96086 5.71071 4.46957 5.5 5 5.5"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_261_1020">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const CaseStudies = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 20H5.2C4.07989 20 3.51984 20 3.09202 19.782C2.71569 19.5903 2.40973 19.2843 2.21799 18.908C2 18.4802 2 17.9201 2 16.8V7.2C2 6.07989 2 5.51984 2.21799 5.09202C2.40973 4.71569 2.71569 4.40973 3.09202 4.21799C3.51984 4 4.07989 4 5.2 4H5.6C7.84021 4 8.96031 4 9.81596 4.43597C10.5686 4.81947 11.1805 5.43139 11.564 6.18404C12 7.03968 12 8.15979 12 10.4M12 20V10.4M12 20H18.8C19.9201 20 20.4802 20 20.908 19.782C21.2843 19.5903 21.5903 19.2843 21.782 18.908C22 18.4802 22 17.9201 22 16.8V7.2C22 6.07989 22 5.51984 21.782 5.09202C21.5903 4.71569 21.2843 4.40973 20.908 4.21799C20.4802 4 19.9201 4 18.8 4H18.4C16.1598 4 15.0397 4 14.184 4.43597C13.4314 4.81947 12.8195 5.43139 12.436 6.18404C12 7.03968 12 8.15979 12 10.4"
				stroke="#2C52F7"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
};

export const LIMS = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_261_8503)">
				<path d="M24 0H0V24H24V0Z" fill="white" />
				<path
					d="M9.48828 6.86035H14.5183V19.3604C14.5183 20.7504 13.3883 21.8704 12.0083 21.8704C10.6183 21.8704 9.49828 20.7404 9.49828 19.3604V6.86035H9.48828Z"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M16.5984 3.90039H7.39844V6.86039H16.5984V3.90039Z"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M9.48828 9.75977H11.8183V17.3798H9.48828"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M9.48828 3.90039V6.86039"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M14.5117 6.86039V3.90039"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M12 3.90039V6.86039"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_261_8503">
					<rect width="24" height="24" rx="2" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const ELN = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_261_13434)">
				<path d="M24 0H0V24H24V0Z" fill="white" />
				<path
					d="M19.2008 20.4303H4.80078V3.57031H12.0008L15.3508 7.43031L19.2008 12.0003V20.4303Z"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M2.85156 6.54004H6.85156"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M2.85156 11.0098H6.85156"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M2.85156 15.4902H6.85156"
					stroke="#2C52F7"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_261_13434">
					<rect width="24" height="24" rx="2" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const Blockquote = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_621_3506)">
				<path
					d="M6 15H21"
					stroke="#5D7AF9"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M21 19H6"
					stroke="#5D7AF9"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M15 11H21"
					stroke="#5D7AF9"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M21 7H15"
					stroke="#5D7AF9"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M9 9H10C10.1978 9 10.3911 9.05865 10.5556 9.16853C10.72 9.27841 10.8482 9.43459 10.9239 9.61732C10.9996 9.80004 11.0194 10.0011 10.9808 10.1951C10.9422 10.3891 10.847 10.5673 10.7071 10.7071C10.5673 10.847 10.3891 10.9422 10.1951 10.9808C10.0011 11.0194 9.80004 10.9996 9.61732 10.9239C9.43459 10.8482 9.27841 10.72 9.16853 10.5556C9.05865 10.3911 9 10.1978 9 10V7.5C9 6.96957 9.21071 6.46086 9.58579 6.08579C9.96086 5.71071 10.4696 5.5 11 5.5"
					stroke="#5D7AF9"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M3 9H4C4.19778 9 4.39112 9.05865 4.55557 9.16853C4.72002 9.27841 4.84819 9.43459 4.92388 9.61732C4.99957 9.80004 5.01937 10.0011 4.98079 10.1951C4.9422 10.3891 4.84696 10.5673 4.70711 10.7071C4.56725 10.847 4.38907 10.9422 4.19509 10.9808C4.00111 11.0194 3.80004 10.9996 3.61732 10.9239C3.43459 10.8482 3.27841 10.72 3.16853 10.5556C3.05865 10.3911 3 10.1978 3 10V7.5C3 6.96957 3.21071 6.46086 3.58579 6.08579C3.96086 5.71071 4.46957 5.5 5 5.5"
					stroke="#5D7AF9"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_621_3506">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const CaretDown = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			{...props}
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5.00024 7.5L10.0002 12.5L15.0002 7.5"
				stroke="currentColor"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
};
